import { c as _c } from "react/compiler-runtime";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { InfoChips } from "@website/ui/info-chips";
import { numberConvert } from "@website/utils/number-convert";
import { CheckboxItemEventTypes, FiltersSchemaType } from "@website/widget/filter";
import mapValues from "lodash-es/mapValues";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { handleTrackingEvent } from "../../map/index.tracking";
import { fetchPropertyDynamicFilters } from "./index.server";
import { handleCategoryBadgeFilterClicked } from "./index.tracking";
export const ratesInfoChips = {
  "4.5": {
    text: "عالی",
    color: "success"
  },
  "4": {
    text: "خیلی خوب",
    color: "success"
  },
  "3.5": {
    text: "خوب",
    color: "default"
  }
};
export const useVillaFiltersSchema = isListingDataFetched => {
  const $ = _c(69);
  const router = useRouter();
  const t0 = String(router.query.locationType);
  const t1 = String(router.query.cityTitle);
  const t2 = String(router?.query?.date_from);
  const t3 = String(router?.query?.date_to);
  const t4 = Boolean(router.query.nearby);
  let t5;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = ["villa_dynamic_filters", t0, t1, t2, t3, t4];
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== router.query.cityTitle || $[7] !== router.query.date_from || $[8] !== router.query.date_to || $[9] !== router.query.locationType || $[10] !== router.query.nearby) {
    t6 = () => fetchPropertyDynamicFilters(String(router.query.locationType), String(router.query.cityTitle), String(router?.query?.date_from), String(router?.query?.date_to), false, Boolean(router?.query?.nearby)).then(_temp);
    $[6] = router.query.cityTitle;
    $[7] = router.query.date_from;
    $[8] = router.query.date_to;
    $[9] = router.query.locationType;
    $[10] = router.query.nearby;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isListingDataFetched || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      enabled: isListingDataFetched,
      queryKey: t5,
      queryFn: t6
    };
    $[12] = isListingDataFetched;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const {
    data: data_0
  } = useFetcher(t7);
  let t8;
  if ($[16] !== router.query.cityTitle || $[17] !== router.query.date_from || $[18] !== router.query.date_to) {
    t8 = item => {
      handleCategoryBadgeFilterClicked({
        item_id: item.name,
        item: item.label,
        isChecked: item.isChecked,
        city_id: Number(router?.query?.cityTitle),
        date_from: toString(router.query?.date_from),
        date_to: toString(router.query?.date_to)
      });
    };
    $[16] = router.query.cityTitle;
    $[17] = router.query.date_from;
    $[18] = router.query.date_to;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const onChangeCategoryBadge = t8;
  let t9;
  if ($[20] !== data_0?.facilities) {
    t9 = data_0?.facilities?.length > 0 ? {
      facilities: {
        type: "checkbox",
        title: "\u0627\u0645\u06A9\u0627\u0646\u0627\u062A \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
        collapsible: data_0?.facilities.length >= 5,
        options: data_0?.facilities?.map(_temp2)
      }
    } : {};
    $[20] = data_0?.facilities;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = data_0?.priceRange?.min;
  const t11 = data_0?.priceRange?.max;
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = {
      title: "\u0642\u06CC\u0645\u062A",
      description: "\u0645\u062C\u0645\u0648\u0639 \u0642\u06CC\u0645\u062A",
      type: "range",
      min_key: "price_from",
      max_key: "price_to",
      step: 100000,
      min: t10,
      max: t11
    };
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== data_0?.accommodations) {
    t13 = data_0?.accommodations?.length > 0 ? {
      type: {
        type: "checkbox",
        title: "\u0646\u0648\u0639 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
        isNew: true,
        collapsible: data_0?.accommodations?.length > 5,
        options: data_0?.accommodations?.map(_temp3) || []
      }
    } : {};
    $[25] = data_0?.accommodations;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== data_0?.categories || $[28] !== data_0?.instant || $[29] !== onChangeCategoryBadge) {
    t14 = data_0?.instant ? {
      categories: {
        type: "checkbox",
        title: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0627\u062A \u0648\u06CC\u0698\u0647",
        onChange: onChangeCategoryBadge,
        options: [{
          label: "\u0631\u0632\u0631\u0648 \u0622\u0646\u06CC",
          name: "instant"
        }, ...(data_0?.categories?.map(_temp4) || [])]
      }
    } : {};
    $[27] = data_0?.categories;
    $[28] = data_0?.instant;
    $[29] = onChangeCategoryBadge;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t9) {
    t15 = {
      ...t9,
      price_range: t12,
      ...t13,
      ...t14
    };
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t9;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const chipsFiltersSchema = t15;
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      type: "input",
      title: "\u062C\u0633\u062A\u062C\u0648 \u0628\u0631 \u0627\u0633\u0627\u0633 \u0646\u0627\u0645 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"
    };
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = data_0?.priceRange?.min;
  const t18 = data_0?.priceRange?.max;
  let t19;
  if ($[37] !== t17 || $[38] !== t18) {
    t19 = {
      title: "\u0642\u06CC\u0645\u062A",
      description: "\u0645\u062C\u0645\u0648\u0639 \u0642\u06CC\u0645\u062A",
      type: "range" as const,
      min_key: "price_from",
      max_key: "price_to",
      step: 100000,
      min: t17,
      max: t18
    };
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== data_0?.accommodations) {
    t20 = data_0?.accommodations?.length > 0 ? {
      type: {
        type: "checkbox" as const,
        title: "\u0646\u0648\u0639 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
        hasSearch: false,
        collapsible: data_0?.accommodations?.length > 5,
        options: data_0?.accommodations?.map(_temp5) || []
      }
    } : {};
    $[40] = data_0?.accommodations;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== data_0?.rates || $[43] !== router.locale) {
    t21 = data_0?.rates.length > 0 ? {
      rate: {
        type: "radio",
        title: "\u0627\u0645\u062A\u06CC\u0627\u0632 \u06A9\u0627\u0631\u0628\u0631\u0627\u0646",
        defaultValue: "all",
        items: [{
          value: "all",
          label: "\u0647\u0645\u0647"
        }, ...(data_0?.rates || []).map(rate => ({
          value: rate === 0 ? "new" : String(rate),
          icon: ratesInfoChips[String(rate)] ? <InfoChips StartIcon={<MaterialIcon className="text-body-2" name="stars" />} color={ratesInfoChips[String(rate)]?.color || ""} size="medium" text={ratesInfoChips[String(rate)]?.text || ""} variant="round-accent" /> : undefined,
          label: rate === 0 ? "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u06CC \u0628\u062F\u0648\u0646 \u0627\u0645\u062A\u06CC\u0627\u0632" : `${numberConvert(rate, {
            locale: router.locale
          })}+ امتیاز`
        }))]
      }
    } : {};
    $[42] = data_0?.rates;
    $[43] = router.locale;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== data_0?.nearby) {
    t22 = data_0?.nearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" ? {
      nearby: {
        type: "switch",
        title: "\u0646\u0645\u0627\u06CC\u0634 \u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"
      }
    } : {};
    $[45] = data_0?.nearby;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== data_0?.geo_property_summary || $[48] !== router.query.locationType || $[49] !== router.query.nearby) {
    t23 = data_0?.geo_property_summary?.length > 1 && (router.query?.locationType === "state" || router.query?.locationType === "city" || router.query?.locationType === "category") ? {
      geo_property_summary: {
        type: "checkbox",
        title: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u0647\u0631",
        isNew: true,
        collapsible: data_0?.geo_property_summary.length > 5,
        options: data_0?.geo_property_summary?.map(geo_property => ({
          name: `${String(geo_property?.geo_slug)}___${String(geo_property?.geo_type)}___${router.query?.nearby ?? false}`,
          label: geo_property?.title
        }))
      }
    } : {};
    $[47] = data_0?.geo_property_summary;
    $[48] = router.query.locationType;
    $[49] = router.query.nearby;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== data_0?.categories || $[52] !== data_0?.instant || $[53] !== onChangeCategoryBadge) {
    t24 = data_0?.categories?.length > 0 ? {
      categories: {
        type: "checkbox" as const,
        title: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0627\u062A \u0648\u06CC\u0698\u0647",
        onChange: onChangeCategoryBadge,
        options: [...(data_0?.instant ? [{
          label: "\u0631\u0632\u0631\u0648 \u0622\u0646\u06CC",
          name: "instant"
        }] : []), ...(data_0?.categories?.map(_temp6) || [])]
      }
    } : {};
    $[51] = data_0?.categories;
    $[52] = data_0?.instant;
    $[53] = onChangeCategoryBadge;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== data_0?.facilities) {
    t25 = data_0?.facilities?.length > 0 ? {
      facilities: {
        type: "checkbox",
        title: "\u0627\u0645\u06A9\u0627\u0646\u0627\u062A \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
        collapsible: data_0?.facilities.length > 5,
        options: data_0?.facilities?.map(_temp7)
      }
    } : {};
    $[55] = data_0?.facilities;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t19 || $[58] !== t20 || $[59] !== t21 || $[60] !== t22 || $[61] !== t23 || $[62] !== t24 || $[63] !== t25) {
    t26 = {
      q: t16,
      price_range: t19,
      ...t20,
      ...t21,
      ...t22,
      ...t23,
      ...t24,
      ...t25
    };
    $[57] = t19;
    $[58] = t20;
    $[59] = t21;
    $[60] = t22;
    $[61] = t23;
    $[62] = t24;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  const t27 = data_0?.nearby;
  let t28;
  if ($[65] !== chipsFiltersSchema || $[66] !== t26 || $[67] !== t27) {
    t28 = {
      filtersSchema: t26,
      hasNearby: t27,
      chipsFiltersSchema,
      trackingCallback: _temp9
    };
    $[65] = chipsFiltersSchema;
    $[66] = t26;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  return t28;
};
function _temp(data) {
  return data;
}
function _temp2(facility) {
  return {
    name: String(facility?.id),
    label: facility?.title,
    icon: <MaterialIcon className="text-on-surface-medium-emphasis text-headline-5" name={facility.icon === "what.ico" || !facility.icon ? "check_box" : facility.icon as MaterialNameType} variant="outlined" />
  };
}
function _temp3(accommodation) {
  return {
    name: accommodation.type,
    label: accommodation.label
  };
}
function _temp4(category) {
  return {
    name: String(category.id),
    label: category.title
  };
}
function _temp5(accommodation_0) {
  return {
    name: accommodation_0.type,
    label: accommodation_0.label
  };
}
function _temp6(category_0) {
  return {
    name: String(category_0.id),
    label: category_0.title
  };
}
function _temp7(facility_0) {
  return {
    name: String(facility_0?.id),
    label: facility_0?.title,
    icon: <MaterialIcon className="text-on-surface-medium-emphasis text-headline-5" name={facility_0.icon === "what.ico" || !facility_0.icon ? "check_box" : facility_0.icon as MaterialNameType} variant="outlined" />
  };
}
function _temp8(value, key) {
  return handleTrackingEvent(USER_TRACKING_EVENTS.FILTER_PILL_REMOVED, {
    removed_filter_name: key,
    removed_filter_value: value
  });
}
function _temp9(t0) {
  const {
    removed
  } = t0;
  mapValues(removed, _temp8);
}